// extracted by mini-css-extract-plugin
module.exports = {"faq":"P90BasketPage_faq__mfHo2"};